import { type ComponentType } from 'react';
import { type TestProps } from '@direct-frontend/components';
import { getOnboardingVariant, type OnboardingVariant } from '#shared/api/onboarding';
import { ExternalOnboardingStepper } from './components/ExternalOnboardingStepper';
import { KitOnboardingStepper } from './components/KitOnboardingStepper';
import { LiteOnboardingStepper } from './components/LiteOnboardingStepper';

const onboardingSteppersByVariant: Record<OnboardingVariant, ComponentType<TestProps>> = {
    kit: KitOnboardingStepper,
    external: ExternalOnboardingStepper,
    lite: LiteOnboardingStepper,
};

export const OnboardingStepper = ({ 'data-testid': dataTestId = 'OnboardingStepper' }: TestProps) => {
    const currentOnboardingVariant = getOnboardingVariant();
    const VariantStepper = onboardingSteppersByVariant[currentOnboardingVariant];

    return <VariantStepper data-testid={dataTestId} />;
};
